import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { ConfigService } from '../config/config.service';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl: string;
  private tokenKey = 'authToken';

  constructor(
    private activatedRoute: ActivatedRoute,
    private configService: ConfigService,
    private msalService: MsalService
  ) {
    this.baseUrl = this.configService.authApi;
  }

  onLogin(token: string): Promise<void> {
    return new Promise((resolve) => {
      localStorage.setItem(this.tokenKey, token);
      resolve();
    });
  }

  logout() {
    this.msalService.logout();
    this.onLogout();
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  getToken(): string | null {
    const token = this.getTokenFromUrl();
    if (token) {
      return token;
    }

    return localStorage.getItem(this.tokenKey);
  }

  getTokenFromUrl(): string | null {
    let token: string | null = null;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['token']) {
        token = params['token'];
        localStorage.setItem(this.tokenKey, params['token']);
      }
    });

    return token;
  }

  onLogout(): void {
    localStorage.removeItem(this.tokenKey);
  }

  clearLocalStorage(): void {
    localStorage.removeItem(this.tokenKey);
  }

  getUserIdFromToken(): string | null {
    const token = localStorage.getItem(this.tokenKey);
    if (token) {
      try {
        const decodedToken: any = jwtDecode(token);
        return decodedToken.oid || null;
      } catch (error) {
        console.error('Invalid token in storage', error);
        return null;
      }
    }
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount) {
      const allAccounts = this.msalService.instance.getAllAccounts();
      if (allAccounts.length > 0) {
        activeAccount = allAccounts[0];
        this.msalService.instance.setActiveAccount(activeAccount);
      }
    }
    if (activeAccount) {
      return activeAccount.idTokenClaims?.oid || null;
    }
    console.warn('MSAL has no accounts. User is logged out.');
    return null;
  }
}
